import type { ArmyPaintCollection } from "../../../lib/core/ArmyPainter/ArmyPaintCollection.type"

export default function createEmptyArmyPaintCollection(): ArmyPaintCollection {
  return {
    selected: null,
    data: []
  }
}